<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="3000">
      <template v-slot:activator="{ on }">
        <v-btn class="primary" v-on="on">แผนภูมิ</v-btn>
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Ch2</v-card-title
        >
        <v-layout>
          <v-flex xs6 style="margin: auto">
            <v-select
              style="white-space: nowrap"
              label="แสดงกราฟ"
              v-model="selectTop"
              :items="listsTop"
              item-text="desc"
              item-value="code"
              class="text-no-padding"
              placeholder=" "
              @change="readExcel()"
            />
          </v-flex>
        </v-layout>
        <!-- <BarChart  :height="80" :chartData="datacollection"/> -->
        <canvas id="graph" width="1000" height="300"></canvas>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import general from "../js/general.js";
import myFunc from "../js/myFunction";
import { sync } from "vuex-pathify";
import axios from "axios";
import XLSX from "xlsx";
import BarChart from "@/components/BarChart";
import { Bar } from "vue-chartjs";
import { Chart } from "chart.js";

export default {
  name: "VueChartJS",
  extends: Bar,
  components: {
    // LineChart,
    BarChart,
    // PieChart,
    // BubbleChart,
    // Reactive
  },
  data() {
    return {
      setOptions: {
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var tooltipValue =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return parseInt(tooltipValue).toLocaleString();
            },
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                // Include a dollar sign in the ticks
                callback: function (value) {
                  return value.toLocaleString();
                },
              },
            },
          ],
        },
      },
      //datacollection: null,
      myChart: null,
      bar: null,
      //datacollection:null,
      dialog: false,
      listsTop: [
        { desc: "3", code: 3 },
        { desc: "5", code: 5 },
        { desc: "10", code: 10 },
      ],
    };
  },
  computed: {},
  methods: {
    readExcel() {
      if (this.selectTop == 3) {
        console.log("3333333333");
        let ctx = document.getElementById("graph");
        let test1 = [];
        let test2 = [];
        let arrayData = [];
        let url = "Ch2.xlsx";
        axios
          .get(url, { responseType: "arraybuffer" })
          .then((res) => {
            let dataStat = new Uint8Array(res.data);
            let workbook = XLSX.read(dataStat, { type: "array" });
            let worksheet =
              workbook.Sheets["25" + this.$store.state.selectYear];
            let data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            if (data.length == 79) {
              test1 = [];
              test2 = [];
              for (let i = 1; i <= 77; i++) {
                let pushData = {
                  province: data[i][2],
                  no: data[i][3],
                };
                test1.push(pushData);
                //test2.push(data[i][2]);
                test1.sort(function (a, b) {
                  return b.no - a.no;
                });
              }
              let bar = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: ["1"],
                  datasets: [
                    {
                      label: [test1[0].province],
                      data: [test1[0].no],
                    },
                    {
                      label: [test1[1].province],
                      data: [test1[1].no],
                    },
                    {
                      label: [test1[2].province],
                      data: [test1[2].no],
                    },
                  ],
                },
              });
            } else {
              for (let i = 1; i <= 76; i++) {
                let pushData = {
                  province: data[i][2],
                  no: data[i][3],
                };
                test1.push(pushData);
                //test2.push(data[i][2]);
                test1.sort(function (a, b) {
                  return b.no - a.no;
                });
              }
              let bar = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: ["1"],
                  datasets: [
                    {
                      label: [test1[0].province],
                      data: [test1[0].no],
                    },
                    {
                      label: [test1[1].province],
                      data: [test1[1].no],
                    },
                    {
                      label: [test1[2].province],
                      data: [test1[2].no],
                    },
                  ],
                },
              });
              //console.log(test2);
            }
          })
          .catch((err) => {
            this.err = err;
          });
      } else if (this.selectTop == 5) {
        let ctx = document.getElementById("graph");
        let test1 = [];
        let test2 = [];
        let arrayData = [];
        let url = "Ch2.xlsx";
        axios
          .get(url, { responseType: "arraybuffer" })
          .then((res) => {
            let dataStat = new Uint8Array(res.data);
            let workbook = XLSX.read(dataStat, { type: "array" });
            let worksheet =
              workbook.Sheets["25" + this.$store.state.selectYear];
            let data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            console.log(data);
            console.log(data.length);
            if (data.length == 79) {
              test1 = [];
              test2 = [];
              for (let i = 1; i <= 77; i++) {
                let pushData = {
                  province: data[i][2],
                  no: data[i][3],
                };
                test1.push(pushData);
                //test2.push(data[i][2]);
                test1.sort(function (a, b) {
                  return b.no - a.no;
                });
              }
              console.log(test1[0].no);
              let bar = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: ["1"],
                  datasets: [
                    {
                      label: [test1[0].province],
                      data: [test1[0].no],
                    },
                    {
                      label: [test1[1].province],
                      data: [test1[1].no],
                    },
                    {
                      label: [test1[2].province],
                      data: [test1[2].no],
                    },
                    {
                      label: [test1[3].province],
                      data: [test1[3].no],
                    },
                    {
                      label: [test1[4].province],
                      data: [test1[4].no],
                    },
                  ],
                },
              });
            } else {
              for (let i = 1; i <= 76; i++) {
                let pushData = {
                  province: data[i][2],
                  no: data[i][3],
                };
                test1.push(pushData);
                //test2.push(data[i][2]);
                test1.sort(function (a, b) {
                  return b.no - a.no;
                });
              }
              console.log(test1[0].no);
              let bar = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: ["1"],
                  datasets: [
                    {
                      label: [test1[0].province],
                      data: [test1[0].no],
                    },
                    {
                      label: [test1[1].province],
                      data: [test1[1].no],
                    },
                    {
                      label: [test1[2].province],
                      data: [test1[2].no],
                    },
                    {
                      label: [test1[3].province],
                      data: [test1[3].no],
                    },
                    {
                      label: [test1[4].province],
                      data: [test1[4].no],
                    },
                  ],
                },
              });
              console.log(test1);
              //console.log(test2);
            }
          })
          .catch((err) => {
            this.err = err;
          });
      } else if (this.selectTop == 10) {
        console.log("1000101010101");
        let ctx = document.getElementById("graph");
        let test1 = [];
        let test2 = [];
        let arrayData = [];
        let url = "Ch2.xlsx";
        axios
          .get(url, { responseType: "arraybuffer" })
          .then((res) => {
            let dataStat = new Uint8Array(res.data);
            let workbook = XLSX.read(dataStat, { type: "array" });
            let worksheet =
              workbook.Sheets["25" + this.$store.state.selectYear];
            let data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            console.log(data);
            console.log(data.length);
            if (data.length == 79) {
              test1 = [];
              test2 = [];
              for (let i = 1; i <= 77; i++) {
                let pushData = {
                  province: data[i][2],
                  no: data[i][3],
                };
                test1.push(pushData);
                //test2.push(data[i][2]);
                test1.sort(function (a, b) {
                  return b.no - a.no;
                });
              }
              console.log(test1[0].no);
              let bar = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: ["1"],
                  datasets: [
                    {
                      label: [test1[0].province],
                      data: [test1[0].no],
                    },
                    {
                      label: [test1[1].province],
                      data: [test1[1].no],
                    },
                    {
                      label: [test1[2].province],
                      data: [test1[2].no],
                    },
                    {
                      label: [test1[3].province],
                      data: [test1[3].no],
                    },
                    {
                      label: [test1[4].province],
                      data: [test1[4].no],
                    },
                    {
                      label: [test1[5].province],
                      data: [test1[5].no],
                    },
                    {
                      label: [test1[6].province],
                      data: [test1[6].no],
                    },
                    {
                      label: [test1[7].province],
                      data: [test1[7].no],
                    },
                    {
                      label: [test1[8].province],
                      data: [test1[8].no],
                    },
                    {
                      label: [test1[9].province],
                      data: [test1[9].no],
                    },
                  ],
                },
              });
            } else {
              for (let i = 1; i <= 76; i++) {
                let pushData = {
                  province: data[i][2],
                  no: data[i][3],
                };
                test1.push(pushData);
                //test2.push(data[i][2]);
                test1.sort(function (a, b) {
                  return b.no - a.no;
                });
              }
              console.log(test1[0].no);
              let bar = new Chart(ctx, {
                type: "bar",
                data: {
                  labels: ["1"],
                  datasets: [
                    {
                      label: [test1[0].province],
                      data: [test1[0].no],
                    },
                    {
                      label: [test1[1].province],
                      data: [test1[1].no],
                    },
                    {
                      label: [test1[2].province],
                      data: [test1[2].no],
                    },
                    {
                      label: [test1[3].province],
                      data: [test1[3].no],
                    },
                    {
                      label: [test1[4].province],
                      data: [test1[4].no],
                    },
                    {
                      label: [test1[5].province],
                      data: [test1[5].no],
                    },
                    {
                      label: [test1[6].province],
                      data: [test1[6].no],
                    },
                    {
                      label: [test1[7].province],
                      data: [test1[7].no],
                    },
                    {
                      label: [test1[8].province],
                      data: [test1[8].no],
                    },
                    {
                      label: [test1[9].province],
                      data: [test1[9].no],
                    },
                  ],
                },
              });
              console.log(test1);
              //console.log(test2);
            }
          })
          .catch((err) => {
            this.err = err;
          });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.listsTable >>> thead {
  background-color: #673ab7;
  color: white;
  margin-left: 350px;
}
.listsTable >>> .v-datatable thead th.column,
.listsTable >>> .v-datatable thead th.column.sortable.active,
.listsTable >>> .v-datatable thead th.column.sortable:hover,
.listsTable >>> .v-datatable thead th.column.sortable.active i {
  color: white;
  border: 1px solid #ddd;
  padding: 8px;
}
.listsTable >>> .v-table tbody tr:hover:not(.v-datatable__expand-row),
.listsTable >>> .v-table tbody tr[active] {
  color: rgb(i, i, i);
  background-color: #9479c3;
}
.listsTable >>> .v-table tbody td {
  background: white;
  border: 1px solid #ddd;
}
.listsTable >>> .v-table tbody tr:nth-of-type(even) td {
  background: rgb(245, 238, 248);
  border: 1px solid #ddd;
}

/* .listsTable >>> table {
  table-layout: auto;
} */
</style>
